 import { axiosInstance } from './api';
/* Cirrus Admin-Service /locations Controller */
const DOWNLOADS_ENDPOINT = 'admin-service/client/downloads';

export default class DownloadsAPI {
    static getDownloads() {
         return axiosInstance.get(DOWNLOADS_ENDPOINT)
    }
}